import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/company-logo_dark-bg_x4.png";
import Spotlight from "./Spotlight";
import { FaXTwitter, FaYoutube, FaBluesky } from "react-icons/fa6";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 className="heading">
                Hotkey Clicker
              </h1>
              <span className="subheading">indie games for RTS enjoyers</span>
            </Col>

            <Col md={5} className="heading-image">
              <img
                src={homeLogo}
                alt="Hotkey Clicker logo"
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </Container>

      <Spotlight />

      <Container fluid className="social-section">
        <Row className="home-about-social-container">
          <Col md={12} className="home-about-social">
            <h1>Follow Us On</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://x.com/HotkeyClicker"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaXTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.youtube.com/@hotkeyclicker"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaYoutube />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://bsky.app/profile/hotkeyclicker.bsky.social"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaBluesky />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
